/** "100 Main St, Moore, OK 73160". Empty when there's no address (a state alone, the default OK, isn't one). */
export function addressLine(a: { street: string; street2?: string; city: string; state: string; zip: string }) {
  if (!a.street && !a.street2 && !a.city && !a.zip) return "";
  const cityLine = [a.city, [a.state, a.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return [a.street, a.street2, cityLine].filter(Boolean).join(", ");
}

/** Straight-line distance in meters between two points (haversine). */
export function distanceMeters(a: { lat: number; lon: number }, b: { lat: number; lon: number }): number {
  const rad = (d: number) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLon = rad(b.lon - a.lon);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * 6_371_000 * Math.asin(Math.sqrt(h));
}

/** "40 m away", "1.2 mi away". */
export function distanceLabel(m: number): string {
  return m < 300 ? `${Math.round(m / 10) * 10 || 10} m away` : `${(m / 1609.34).toFixed(m < 16_000 ? 1 : 0)} mi away`;
}
